export const GlobalMetalLogo = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="assets/metals/global">
        <path
          id="Shape-gold"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 19.9999C39.9998 8.95435 31.0455 0 19.9998 0C8.95431 0 0 8.95435 0 19.9999C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 19.9999ZM15.625 20H9.375C8.85394 20 8.38754 20.3232 8.20459 20.8111L6.32959 25.8111C6.02314 26.6283 6.62724 27.5 7.5 27.5H17.5C18.3728 27.5 18.9769 26.6283 18.6704 25.8111L16.7954 20.8111C16.6125 20.3232 16.1461 20 15.625 20ZM16.875 10H23.125C23.6461 10 24.1125 10.3232 24.2954 10.8111L26.1704 15.8111C26.4769 16.6283 25.8728 17.5 25 17.5H15C14.1272 17.5 13.5231 16.6283 13.8296 15.8111L15.7046 10.8111C15.8875 10.3232 16.3539 10 16.875 10ZM30.625 20H24.375C23.8539 20 23.3875 20.3232 23.2046 20.8111L21.3296 25.8111C21.0231 26.6283 21.6272 27.5 22.5 27.5H32.5C33.3728 27.5 33.9769 26.6283 33.6704 25.8111L31.7954 20.8111C31.6125 20.3232 31.1461 20 30.625 20Z"
          fill="#B68E46"
        />
      </g>
    </svg>
  );
};
